import { getGameImage } from '@/scripts/utils';
import { findGame } from '@/scripts/utils/collection';

const gameSetup = context => {
  const { games, activeGame } = context;
  const result = games.find(({ id }) => id === activeGame);

  return result;
};

const banners = context => {
  const { gameSetup } = context;
  const { images } = gameSetup;
  const reg = /^dashboard_banner_\d+$/;
  const result = [];

  Object.entries(images).forEach(([key = '', val]) => {
    if (reg.test(key)) result.push(val);
  });

  return result;
};

const onboardingBackground = context => {
  const { activeGame } = context;

  if (!activeGame) return null;

  const game = findGame(activeGame);

  if (!game) return null;

  const result = getGameImage(game, { style: true, field: 'bg' });

  return result;
};

const mobile = context => {
  const { $mq: mq } = context;

  const result = mq === 'mobile';

  return result;
};

const isFormValid = context => {
  const { email } = context;
  const result = !!context.checkEmailValid(email);

  return result;
};

const rushBalance = context => {
  const { balances } = context;
  const { RUSH = 0 } = balances || {};

  return RUSH;
};

const currentGameTypes = context => {
  const { allGamesTypes, activeGame } = context;
  const result = allGamesTypes[activeGame] || null;

  return result;
};

const gameTypeSetup = context => {
  const { currentGameTypes, activeGameType } = context;

  if (!currentGameTypes) return null;

  const match = currentGameTypes.find(({ id }) => id === activeGameType);
  const result = match;

  return result;
};

export {
  gameSetup,
  banners,
  onboardingBackground,
  mobile,
  isFormValid,
  rushBalance,
  currentGameTypes,
  gameTypeSetup,
};
